import { render, staticRenderFns } from "./InventoryListTable.vue?vue&type=template&id=40bbaf84&scoped=true&"
import script from "./InventoryListTable.vue?vue&type=script&lang=js&"
export * from "./InventoryListTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListTable.vue?vue&type=style&index=0&id=40bbaf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbaf84",
  null
  
)

export default component.exports